import { useEffect } from "react";
import { useIsMobile } from "./useIsMobile";
import { useMobileEdgeChromeStore } from "../stores/mobileEdgeChromeStore";

/** Ref-counts mobile edge chrome suppression while a custom/context menu is open (narrow viewports only). */
export function useSyncMobileEdgeChromeFromMenuOpen(isOpen) {
  const isMobile = useIsMobile();

  useEffect(() => {
    if (!isMobile || !isOpen) return;
    const { notifyMenuOverlayOpenChange } = useMobileEdgeChromeStore.getState().actions;
    notifyMenuOverlayOpenChange(true);
    return () => notifyMenuOverlayOpenChange(false);
  }, [isMobile, isOpen]);
}
